


/* CART - TOTAL FIXED BOTTOM */

let fixedTotal = document.querySelector('.cart__blocks--fixed-mobile');
if (fixedTotal) {
  document.addEventListener('scroll', function() {
    if (document.querySelector('.cart__footer .cart__blocks').getBoundingClientRect().top < window.innerHeight - fixedTotal.getBoundingClientRect().height) {
      fixedTotal.style.bottom = '-' + fixedTotal.getBoundingClientRect().height + 'px';
      fixedTotal.style.boxShadow = 'none';
    }
    else {
      fixedTotal.style.bottom = '0';
      fixedTotal.style.boxShadow = '0 -2px 10px rgba(0,0,0,0.1)';
    }
  })
}



/* COLLECTION CAROUSEL */
  
function collectionTab(evt, collectionName, sectionId) {
  // Declare all variables
  var i, tabcontent, tablinks;
  
  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  
  for (i = 0; i < tabcontent.length; i++) {

    if (tabcontent[i].classList.contains(sectionId)) {
      tabcontent[i].style.display = "none";
      tabcontent[i].classList.remove('active');
    }
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    if (tablinks[i].classList.contains(sectionId)) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(collectionName).style.display = "block";
  document.getElementById(collectionName).classList.add('active');
  if (evt.currentTarget.classList.contains(sectionId)) {
    evt.currentTarget.className += " active";
  }
}

/* CUSTOM REBUY BABYLIFE CAROUSEL COLLECTION */
function rebuyCollectionTab(evt, collectionName) {
  let i, tabcontent, tablinks;

  tabcontentProdotti = document.getElementsByClassName('custom-tabcontent-prodotti')[0].children
  tabcontentCategorie = document.getElementsByClassName('custom-tabcontent-categorie')[0].children
  tablinksProdotti = document.getElementsByClassName('prodotti')[0].children
  tablinksCategorie = document.getElementsByClassName('categorie')[0].children

  if (collectionName.startsWith('prodotti-')) {
    for (i = 0; i < tabcontentProdotti.length; i++) {
      tabcontentProdotti[i].style.display = "none";
    }
  }

  if (collectionName.startsWith('categorie-')) {
    for (i = 0; i < tabcontentCategorie.length; i++) {
      tabcontentCategorie[i].style.display = "none";
    }
  }
 

  if (collectionName.startsWith('prodotti-')) {
    for (i = 0; i < tablinksProdotti.length; i++) {
      tablinksProdotti[i].className = tablinksProdotti[i].className.replace(" active", "")
    }
  }

  if (collectionName.startsWith('categorie-')) {
    for (i = 0; i < tablinksCategorie.length; i++) {
      tablinksCategorie[i].className = tablinksCategorie[i].className.replace(" active", "")    }
  }
  if (collectionName.includes('prodotti-') || collectionName.includes('categorie-')) {
    document.getElementById(collectionName).style.display = "block";
    evt.target.className += " active";
  }
}